interface ICommonFormField {
  reportingCategoryMajorName: string;
  reportingCategoryMajorEntityId: string;
  reportingCategoryMajorExCategoryId: string;
  reportingCategoryMinorName: string;
  reportingCategoryMinorEntityId: string;
  reportingCategoryMinorExCategoryId: string;
}

const COMMON_FORM_PATH: Record<keyof ICommonFormField, string> = {
  reportingCategoryMajorName: 'reporting_category_major.name',
  reportingCategoryMajorEntityId: 'reporting_category_major.entity_id',
  reportingCategoryMajorExCategoryId:
    'reporting_category_major.external_category_id',
  reportingCategoryMinorName: 'reporting_category_minor.name',
  reportingCategoryMinorEntityId: 'reporting_category_minor.entity_id',
  reportingCategoryMinorExCategoryId:
    'reporting_category_minor.external_category_id',
};

const MajorReportingCategoryPath =
  'reporting_category.major_reporting_category.name';
const MinorReportingCategoryPath =
  'reporting_category.minor_reporting_category.name';

export {
  COMMON_FORM_PATH,
  MajorReportingCategoryPath,
  MinorReportingCategoryPath,
};
